import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVideoGalleryThunk } from "../redux/videoGallerySlice";

export default function useVideoGallery() {
    const dispatch = useDispatch();
    const { videos, status, error } = useSelector(
        (state) => state.videoGallery
    );

    useEffect(() => {
        if (status === "idle") {
            dispatch(fetchVideoGalleryThunk());
        }
    }, [status, dispatch]);

    return { videos, status, error };
}
